const getSafeInteger = (value: unknown) => {
  const number = Number(value);
  return Number.isFinite(number) ? Math.trunc(number) : 0;
};

export const getRussianPluralForm = (
  value: number,
  one: string,
  few: string,
  many: string
) => {
  const number = Math.abs(getSafeInteger(value));
  const lastTwoDigits = number % 100;
  const lastDigit = number % 10;

  if (lastTwoDigits >= 11 && lastTwoDigits <= 14) return many;
  if (lastDigit === 1) return one;
  if (lastDigit >= 2 && lastDigit <= 4) return few;
  return many;
};

export const formatRussianWeeks = (value: number) => {
  const number = getSafeInteger(value);
  return `${number} ${getRussianPluralForm(number, "неделя", "недели", "недель")}`;
};
